module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.scss
// module id = ./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.scss
// module chunks = 0